module.exports = __webpack_public_path__ + "img/erweima.9a9cf7b1.png";